export const { VITE_GOOGLE_PLACES_API_KEY: GOOGLE_PLACES_API_KEY } = import.meta.env
